"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

exports.__esModule = true;
exports.default = void 0;

var _icon = require("@platform-ui/icon");

var _Trash = _interopRequireDefault(require("./Trash.svg"));

var _default = (0, _icon.getInterface24IconClass)(_Trash.default);

exports.default = _default;